import clsx from 'clsx'
import { Box, Grid, makeStyles, TextField, Typography } from '@material-ui/core'
import { useState } from 'react'
import { HexColorPicker } from 'react-colorful'
import CabinComponentManager from './CabinComponentManager'

const useStyles = makeStyles(() => ({
  root: {}
}))

function PVCabinContent ({ className, ...rest }) {
  const classes = useStyles()

  const { element, setElement, assets } = rest

  const name = element?.config?.[0]?.data?.draw?.name || ''
  const color = element?.config?.[0]?.data?.draw?.borderColor || 'gray'
  const selectedComponents = element?.config?.[0]?.additionalData?.selectedComponents ?? []

  const [currentName, setCurrentName] = useState(name)
  const [currentColor, setCurrentColor] = useState(color)
  const [currentSelectedComponents, setCurrentSelectedComponents] = useState(selectedComponents)

  const handlePropertySelection = (componentConfigurations) => {
    setCurrentSelectedComponents(componentConfigurations)

    setElement(prevElement => {
      if (prevElement.config.length > 0) {
        prevElement.config[0].additionalData = {
          ...prevElement.config[0].additionalData,
          selectedComponents: componentConfigurations
        }
      } else {
        prevElement.config.push({
          ...prevElement.config?.[0],
          additionalData: {
            selectedComponents: componentConfigurations
          }
        })
      }

      return ({
        config: [{
          ...prevElement.config[0]
        }]
      })
    })
  }

  return (
    <div className={clsx(classes.root, className)}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={9}>
          <Box my={2} width='100%'>
            <TextField
              fullWidth
              size='small'
              variant='outlined'
              label='Nome cabina FV'
              placeholder='Nome'
              value={currentName || ''}
              onChange={(e) => {
                e.persist()
                setElement(prevElement => {
                  if (prevElement.config.length > 0) {
                    // se l'elemento non ha l'oggetto data lo imposto a oggetto vuoto
                    if (!prevElement.config[0].data) {
                      prevElement.config[0].data = {}
                    }
                    // se l'elemento non ha l'oggetto draw lo imposto a oggetto vuoto
                    if (!prevElement.config[0].data.draw) {
                      prevElement.config[0].data.draw = {}
                    }
                    prevElement.config[0].data.draw = {
                      ...prevElement.config[0].data.draw,
                      name: e.target.value
                    }
                  } else {
                    prevElement.config.push({
                      assets: [],
                      data: {
                        draw: {
                          name: e.target.value
                        }
                      }
                    })
                  }
                  return { ...prevElement }
                })
                setCurrentName(e.target.value)
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant='h6'>Colore di sfondo</Typography>
          <Box my={2} width='100%'>
            <HexColorPicker
              style={{ height: '100px' }} color={currentColor} onChange={setCurrentColor} onMouseUp={(e) => {
                e.persist()
                setElement((prevElement) => {
                  if (prevElement.config.length > 0) {
                    if (!prevElement.config[0].data?.draw) {
                      prevElement.config[0].data.draw = {}
                    }
                    prevElement.config[0].data.draw = {
                      ...prevElement.config[0].data.draw,
                      borderColor: currentColor
                    }
                  } else {
                    prevElement.config.push({
                      devices: [],
                      data: {
                        draw: {
                          borderColor: currentColor
                        }
                      }
                    })
                  }
                  return { ...prevElement }
                })
              }}
            />
          </Box>
        </Grid>
      </Grid>
      <Box>
        <CabinComponentManager components={currentSelectedComponents} onChange={handlePropertySelection} assets={assets} />
      </Box>
    </div>
  )
}
export default PVCabinContent
